import React from 'react'
import { DatePicker, Form, Switch } from 'antd'
import moment from 'moment-timezone'
import {
    LimitedScheduleDatesConfiguration,
    MutableLimitedScheduleDatesConfiguration,
} from '@pushly/models/lib/structs/feeds/limited-schedule-dates-configuration'

interface IFeedRunDateEditorProps {
    scheduledDates: LimitedScheduleDatesConfiguration
    onChange(scheduledDates: LimitedScheduleDatesConfiguration): void
}

export const FeedScheduledDatesEditor = ({ scheduledDates, onChange }: IFeedRunDateEditorProps) => {
    return (
        <>
            <Form.Item label="Start Date">
                <Form.Item>
                    <DatePicker
                        id="scheduled-date-start"
                        size="small"
                        value={moment(scheduledDates.startDate)}
                        format="ddd, LL"
                        onChange={(v) => {
                            const nextScheduleDates = new MutableLimitedScheduleDatesConfiguration()

                            nextScheduleDates.startDate = v?.format('YYYY-MM-DD')
                            if (scheduledDates.endDate) {
                                nextScheduleDates.endDate = scheduledDates.endDate
                            }

                            onChange(nextScheduleDates)
                        }}
                    />
                </Form.Item>
            </Form.Item>
            <Form.Item label="End Date">
                <Form.Item className="end-date">
                    <Switch
                        className="scheduled-date-end-toggle"
                        size="small"
                        checked={!!scheduledDates.endDate}
                        onChange={(v) => {
                            const nextScheduleDates = new MutableLimitedScheduleDatesConfiguration()

                            nextScheduleDates.startDate = scheduledDates.startDate
                            if (v) {
                                nextScheduleDates.endDate = moment().add(7, 'days').format('YYYY-MM-DD')
                            }

                            onChange(nextScheduleDates)
                        }}
                    />
                    <DatePicker
                        id="scheduled-date-end"
                        size="small"
                        value={moment(scheduledDates.endDate ?? moment().add(7, 'days').format('YYYY-MM-DD'))}
                        format="ddd, LL"
                        disabled={!scheduledDates.endDate}
                        onChange={(v) => {
                            const nextScheduleDates = new MutableLimitedScheduleDatesConfiguration()

                            nextScheduleDates.startDate = scheduledDates.startDate
                            nextScheduleDates.endDate = v.format('YYYY-MM-DD')

                            onChange(nextScheduleDates)
                        }}
                    />
                </Form.Item>
            </Form.Item>
        </>
    )
}
